import * as React from 'react';
import _ from 'lodash';
import RuleBuilderConfig from './TreatmentRuleBuilderConfig';
import ShowConditions from 'components/rule-builder/ShowConditions';
import { getRuleTypesListForConditionNode } from 'omega-rtc/utils/new-trident-utils';
import { Campaign } from 'types/ts/campaigns';

interface Props {
  setRef: Function,
  model: Campaign,
  currentNode: string,
  parentNode: string,
  parentKeyList: string[],
  listRuleTypes: Object,
};

interface State {
  currentNode: string,
  startingNode: string,
};

export default class ConditionShow extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      currentNode: this.props.currentNode,
      startingNode: this.props.parentKeyList[0],
    };
  }
  render() {
    const { model, listRuleTypes } = this.props;
    const { currentNode, startingNode } = this.state;
    const { ruleTypes, type } = getRuleTypesListForConditionNode(listRuleTypes, model, startingNode);
    return (
      <div>
        {type !== 'TREATMENTS.' &&
          <ShowConditions
            setRef={this.props.setRef}
            model={_.get(model, `nodes.${currentNode}.data`)}
            config={RuleBuilderConfig}
            type={type}
            hideTitle
            systemType="newtrident"
            ruleTypes={ruleTypes}
            ruleTypesPassedFromSystem
          />
        }
      </div>
    );
  }
}
